<template>
  <v-dialog v-model="isOpen" max-width="80%" scrollable>
    <v-card v-if="packageDetail">
      <v-card-text>
        <v-card elevation="0">
          <v-card-title>
            <v-spacer></v-spacer>
            <circle-button @click="close" icon="mdi-close"></circle-button>
          </v-card-title>
          <v-card-text class="mb-0">
            <v-row>
              <v-card-text align="center" class="title" style="margin-top: -40px">
                <h3>{{ $t("package_no") }}: #{{ packageDetail.id }}</h3>
              </v-card-text>
              <v-card elevation="0" class="pa-5" style="width: 100%">
                <v-row style="width: 100%">
                  <v-col class="mb-0 pb-0" cols="12">
                    <p class="font-weight-black">
                      {{ $t("recipient_pays_postage") }} |
                      {{ packageDetail.send_date }}
                    </p>
                  </v-col>

                  <!-- Sender & Receiver Address -->
                  <v-col cols="4">
                    <sender-receiver-info
                      :sender="packageDetail.sender"
                      :sender-location="packageDetail.sender_location"
                      :receiver="packageDetail.receiver"
                      :receiver-location="packageDetail.receiver_location"
                    />
                  </v-col>

                  <!-- Service Type Details -->
                  <v-col cols="4">
                    <service-type-details
                      :package-detail="packageDetail"
                      :time-delivery="timeDelivery"
                      @update:time-delivery="timeDelivery = $event"
                    />
                  </v-col>

                  <!-- Pickup Data -->
                  <v-col cols="4">
                    <pickup-data :package-detail="packageDetail" />
                  </v-col>
                </v-row>
              </v-card>
            </v-row>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import SenderReceiverInfo from "./SenderReceiverInfo.vue";
import ServiceTypeDetails from "./ServiceTypeDetails.vue";
import PickupData from "./PickupData.vue";

export default {
  name: "PostPackageDetailDialog",
  components: {
    SenderReceiverInfo,
    ServiceTypeDetails,
    PickupData,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    packageDetail: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      timeDelivery: false,
    };
  },
  computed: {
    isOpen: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    close() {
      this.isOpen = false;
    },
  },
};
</script>
